export default "__VITE_ASSET__CH_CPaFD__"